import type { Role } from '../domain/models'

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message)
  }
}
let activeRole: Role = 'manager'
let csrfToken = ''
export function setAPIRole(role: Role) {
  activeRole = role
}
function headers() {
  const role = activeRole === 'client' ? 'customer' : activeRole
  return {
    'X-Role': role,
    'X-User-ID': role + '-1',
    'X-CSRF-Token': csrfToken,
  }
}
export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  let response: Response
  try {
    response = await fetch('/api/v1' + path, {
      ...options,
      credentials: 'same-origin',
      signal: options.signal ?? AbortSignal.timeout(20000),
      headers: {
        ...headers(),
        ...(options.body && !(options.body instanceof FormData)
          ? { 'Content-Type': 'application/json' }
          : {}),
        ...options.headers,
      },
    })
  } catch {
    throw new ApiError(0, 'Нет связи с сервером. Проверьте подключение и повторите операцию.')
  }
  if (!response.ok) {
    const body = await response.json().catch(() => null)
    throw new ApiError(
      response.status,
      body?.error?.message ?? body?.message ?? `Ошибка сервера (${response.status})`,
    )
  }
  const envelope = (await response.json()) as { data?: T }
  if (!('data' in envelope)) throw new ApiError(502, 'Сервер вернул неожиданный формат ответа')
  return envelope.data as T
}
export interface Session {
  appMode: string
  csrfToken?: string
  role: string
  roles?: string[]
  user: { id: string; name: string; companyId?: string; department?: string; phone?: string }
}
export async function readSession() {
  const session = await api<Session>('/meta')
  csrfToken = session.csrfToken ?? ''
  return session
}
export async function login(userId: string, password: string) {
  const result = await api<{ csrfToken: string; user: Session['user'] & { role: string } }>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ userId, password }),
  })
  csrfToken = result.csrfToken
  return result.user
}
export async function logout() {
  await api('/auth/logout', { method: 'POST' })
  csrfToken = ''
}
export async function fetchDocument(id: string) {
  const response = await fetch(`/api/v1/mechanization/documents/${encodeURIComponent(id)}/file`, {
    headers: headers(),
    credentials: 'same-origin',
    signal: AbortSignal.timeout(20000),
  })
  if (!response.ok) throw new Error('Оригинал документа недоступен')
  return response.blob()
}
